import $ from "jquery";
import "bootstrap-sass";
import "bootstrap-notify";
// @todo : placer ça dans lib ?
/**
 * Affichage d'une fenêtre modal avec un contenu dynamique
 * @param {string} url URL de la page contenue
 * @param {string} titre Titre de la fenêtre modal
 */
export function openModalIframe(url, titre, forChart = false) {
    $('#modalIframe').text('');
    $('#modalIframeLabel').text(titre);
    $('#modalIframe').hide();
    $('#loadingModalIframe').show();
    var firstChild = $('#modalIframeContent').children()[0];
    var littleChild = $('#modalIframeContent').children().children()[0];
    if (forChart) {
        $(firstChild).css("height", "100%");
        $(firstChild).css("width", '100%');
        $(firstChild).css("padding", "0");
        $(firstChild).css("margin", "0");
        $(littleChild).css("min-height", "100%");
    }
    else {
        $(firstChild).removeAttr('style');
        $(littleChild).removeAttr('style');
    }
    $('#modalIframeContent').modal('show');
    if (url !== null) {
        $('#modalIframe').load(url);
    }
    $('#loadingModalIframe').hide();
    $('#modalIframe').show();
}
export function closeModalIframe() {
    $('#modalIframeContent').modal('hide');
}
export function notify(message, notifyType = 'warning') {
    if ($('div.alert[data-notify]').length === 0) {
        var options = {
            icon: 'fa fa-exclamation-triangle',
            //                title: title,
            message: message
        };
        var settings = {
            type: notifyType,
            newest_on_top: false,
            placement: {
                from: "top",
                align: "center"
            },
            animate: {
                enter: 'animated fadeInDown',
                exit: 'animated fadeOutUp'
            },
            template: '<div data-notify="container" class="col-xs-11 col-sm-3 alert alert-{0}" role="alert">' +
                '<button type="button" aria-hidden="true" class="close" data-notify="dismiss">×</button>' +
                '<span data-notify="icon"></span> ' +
                '<span data-notify="message">{2}</span>' +
                '<div class="progress" data-notify="progressbar">' +
                '<div class="progress-bar progress-bar-{0}" role="progressbar" aria-valuenow="0" aria-valuemin="0" aria-valuemax="100" style="width: 0%;"></div>' +
                '</div>' +
                '<a href="{3}" target="{4}" data-notify="url"></a>' +
                '</div>'
        };
        $.notify(options, settings);
    }
}
//# sourceMappingURL=modal.js.map